import { useEffect } from 'react';

const CHATWOOT_TOKEN = process.env.REACT_APP_CHATWOOT_WEBSITE_TOKEN;
const CHATWOOT_BASE_URL = process.env.REACT_APP_CHATWOOT_BASE_URL || 'https://app.chatwoot.com';

export const ChatwootWidget = () => {
  useEffect(() => {
    // Don't load if token is not configured
    if (!CHATWOOT_TOKEN) {
      // eslint-disable-next-line no-console
      console.info('[Chatwoot] REACT_APP_CHATWOOT_WEBSITE_TOKEN not set - widget disabled');
      return;
    }

    // Avoid duplicate injection on hot-reload / re-render
    if (document.getElementById('chatwoot-sdk')) return;

    // Chatwoot settings
    window.chatwootSettings = {
      position: 'right',
      type: 'standard',
      launcherTitle: 'Chat with us',
      hideMessageBubble: false,
      showPopoutButton: true,
    };

    const script = document.createElement('script');
    script.id = 'chatwoot-sdk';
    script.src = `${CHATWOOT_BASE_URL}/packs/js/sdk.js`;
    script.defer = true;
    script.async = true;

    script.onload = () => {
      if (window.chatwootSDK) {
        window.chatwootSDK.run({
          websiteToken: CHATWOOT_TOKEN,
          baseUrl: CHATWOOT_BASE_URL,
        });
      }
    };

    document.body.appendChild(script);

    return () => {
      // Cleanup on unmount (rare - only on hot reload)
      const s = document.getElementById('chatwoot-sdk');
      if (s && s.parentNode) s.parentNode.removeChild(s);
    };
  }, []);

  return null;
};
